import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function HomePage() {
  const navigate = useNavigate();
  const [joinCode, setJoinCode] = useState('');
  const [showJoin, setShowJoin] = useState(false);

  const handleJoin = () => {
    const code = joinCode.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (code.length === 6) {
      navigate(`/join/${code}`);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-base-100">
      <div className="px-4 max-w-md w-full space-y-8">
        <div className="text-center">
          <h1 className="text-5xl font-black mb-2 text-primary tracking-tight">
            WASTED GAMES
          </h1>
          <p className="text-base-content/60 text-lg">Pick a game. Play. Survive.</p>
        </div>

        {/* Game Cards */}
        <div className="space-y-4">
          {/* Gambit */}
          <div
            onClick={() => navigate('/create')}
            className="card bg-base-200 cursor-pointer hover:bg-base-300 transition-colors"
          >
            <div className="card-body py-5">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="card-title text-xl font-bold">Gambit</h2>
                  <p className="text-base-content/60 text-sm mt-1">
                    Write dares, vote on the best and worst. Multi-device multiplayer.
                  </p>
                </div>
                <span className="badge badge-neutral text-xs">3-20 players</span>
              </div>
            </div>
          </div>

          {/* Do or Drink */}
          <div
            onClick={() => navigate('/doOrDrink')}
            className="card bg-base-200 cursor-pointer hover:bg-base-300 transition-colors"
          >
            <div className="card-body py-5">
              <div className="flex justify-between items-start">
                <div>
                  <h2 className="card-title text-xl font-bold">Do or Drink</h2>
                  <p className="text-base-content/60 text-sm mt-1">
                    Get dared, choose to do it or drink. Single device, pass and play.
                  </p>
                </div>
                <span className="badge badge-neutral text-xs">2+ players</span>
              </div>
            </div>
          </div>
        </div>

        {/* Join Game (Gambit only) */}
        <div className="space-y-2">
          {!showJoin ? (
            <button
              onClick={() => setShowJoin(true)}
              className="btn btn-outline btn-sm w-full"
            >
              Join a Gambit game with code
            </button>
          ) : (
            <div className="flex gap-2">
              <input
                type="text"
                placeholder="Enter code"
                value={joinCode}
                onChange={(e) => setJoinCode(e.target.value.toUpperCase().slice(0, 6))}
                onKeyDown={(e) => e.key === 'Enter' && handleJoin()}
                className="input input-bordered flex-1 text-center tracking-[0.3em] font-mono text-xl"
                maxLength={6}
                autoFocus
              />
              <button
                onClick={handleJoin}
                disabled={joinCode.replace(/[^A-Z0-9]/g, '').length !== 6}
                className="btn btn-primary"
              >
                Go
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
